(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-home-switch')) {
  customElements.define('ls-home-switch', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-ls-tab]')];
      this.panels = [...this.querySelectorAll('[data-ls-panel]')];
      this.photos = [...this.querySelectorAll('[data-ls-photo-panel]')];
      this.index = 0;
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-ls-tab]');
        const step = event.target.closest('[data-ls-step]');
        if (tab) this.select(Number(tab.dataset.lsTab));
        if (step) this.select((this.index + Number(step.dataset.lsStep) + this.tabs.length) % this.tabs.length);
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-ls-tab]');
        if (!tab) return;
        let target = Number(tab.dataset.lsTab);
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) target++;
        else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) target--;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select((target + this.tabs.length) % this.tabs.length);
        this.tabs[this.index].focus();
      });
    }
    select(index) {
      this.index = index;
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.photos.forEach((photo, i) => { photo.hidden = i !== index; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-pages"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-collection-shortcuts')) {
  customElements.define('ls-collection-shortcuts', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const update = () => {
        const params = new URL(location.href).searchParams;
        this.querySelectorAll('[data-ls-filter-param]').forEach(link => {
          const active = params.getAll(link.dataset.lsFilterParam).includes(link.dataset.lsFilterValue);
          if (link.getAttribute('role') === 'switch') link.setAttribute('aria-checked', String(active));
          else if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-ls-filter-param]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const url = new URL(location.href);
        const key = link.dataset.lsFilterParam;
        const value = link.dataset.lsFilterValue;
        const current = url.searchParams.getAll(key);
        url.searchParams.delete(key);
        const values = current.includes(value) ? current.filter(v => v !== value) : [...current, value];
        values.forEach(v => url.searchParams.append(key, v));
        url.searchParams.delete('page');
        location.assign(url.toString());
      }, { signal: this.abort.signal });
      window.addEventListener('popstate', update, { signal: this.abort.signal });
      this.observer = new MutationObserver(update);
      const results = document.querySelector('results-list');
      if (results) this.observer.observe(results, { childList: true, subtree: true });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('ls-brand-browser')) {
  customElements.define('ls-brand-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.letter = 'all';
      this.items = [...this.querySelectorAll('[data-brand-name]')];
      this.search = this.querySelector('[data-brand-search]');
      this.search.addEventListener('input', () => this.filter());
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-brand-letter]');
        if (!button) return;
        this.letter = button.dataset.brandLetter;
        this.querySelectorAll('[data-brand-letter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.filter();
      });
      this.filter();
    }
    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      let count = 0;
      this.items.forEach(item => {
        const initial = item.dataset.brandInitial;
        const letterMatch = this.letter === 'all' || (this.letter === '0-9' ? /^[0-9]$/.test(initial) : initial === this.letter);
        const visible = letterMatch && item.dataset.brandName.includes(query);
        item.hidden = !visible;
        if (visible) count++;
      });
      this.querySelector('[data-brand-count]').textContent = String(count);
      this.querySelector('[data-brand-empty]').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-rack"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-clothes-rack')) {
  customElements.define('ls-clothes-rack', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, {...options, signal});
      this.items = [...this.querySelectorAll('[data-rack-item]')];
      this.panels = [...this.querySelectorAll('[data-rack-info]')];
      this.selected = -1;
      listen(this,'click', event => {
        if (this.swiped) { this.swiped = false; event.preventDefault(); return; }
        const close = event.target.closest('[data-rack-close]');
        if (close) { close.closest('dialog').close(); return; }
        const photo = event.target.closest('[data-rack-photo]');
        if (photo) {
          const dialog = photo.closest('dialog');
          const image = dialog.querySelector('.ls-rack-dialog__photo img');
          image.removeAttribute('srcset');
          image.src = photo.dataset.rackPhoto;
          dialog.querySelectorAll('[data-rack-photo]').forEach(button => button.setAttribute('aria-pressed',String(button === photo)));
          return;
        }
        const open = event.target.closest('[data-rack-open]');
        if (open) { this.openProduct(Number(open.dataset.rackOpen)); return; }
        const item = event.target.closest('[data-rack-item]');
        const step = event.target.closest('[data-rack-step]');
        if (item) { this.select(Number(item.dataset.rackItem)); this.openProduct(Number(item.dataset.rackItem)); }
        if (step) this.select(this.selected < 0 ? (Number(step.dataset.rackStep) > 0 ? 0 : this.items.length - 1) : this.selected + Number(step.dataset.rackStep));
      });
      listen(this,'keydown', event => {
        if (event.target.closest('a, dialog')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.select(this.selected + (event.key === 'ArrowRight' ? 1 : -1));
        this.items[this.selected]?.focus({preventScroll:true});
      });
      this.querySelectorAll('[data-rack-dialog]').forEach(dialog => {
        listen(dialog,'click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
        listen(dialog,'close', () => { this.items[Number(dialog.dataset.rackDialog)]?.focus({preventScroll:true}); });
      });
      listen(this,'change', event => {
        const input = event.target.closest('[data-rack-purchase] input[name="id"]');
        if (!input) return;
        const form = input.form;
        form.querySelectorAll('[data-rack-submit]').forEach(button => { button.disabled = form.dataset.busy === 'true'; });
        form.closest('dialog').querySelector('[data-rack-price]').textContent = input.dataset.price;
      });
      listen(this,'submit', event => {
        if (!event.target.matches('[data-rack-purchase]')) return;
        event.preventDefault();
        this.purchase(event.target,event.submitter?.value === 'checkout');
      });
      const stage = this.querySelector('[data-rack-stage]');
      this.stage = stage;
      const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      let pointerFrame = 0;
      let pendingPointer = null;
      let hoverTimer = 0;
      let hoverCandidate = -1;
      const clearHover = () => {
        clearTimeout(hoverTimer);
        hoverCandidate = -1;
        pendingPointer = null;
        if (pointerFrame) cancelAnimationFrame(pointerFrame);
        pointerFrame = 0;
        if (!this.querySelector('dialog[open]') && !this.querySelector('[data-rack-item]:focus-visible')) this.select(-1);
      };
      const processPointer = () => {
        pointerFrame = 0;
        if (!pendingPointer || this.querySelector('dialog[open]')) return;
        const {x,y} = pendingPointer;
        const rect = stage.getBoundingClientRect();
        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) { clearHover(); return; }
        const lane = ((x - rect.left) / rect.width - .27) / .46;
        if (lane < -.18 || lane > 1.18) { clearHover(); return; }
        const candidate = Math.min(this.items.length - 1,Math.max(0,Math.floor(lane * this.items.length)));
        const garment = this.items[candidate].getBoundingClientRect();
        if (y < Math.max(rect.top,garment.top) || y > Math.min(rect.bottom,garment.bottom)) { clearHover(); return; }
        if (candidate === this.selected || candidate === hoverCandidate) return;
        clearTimeout(hoverTimer);
        hoverCandidate = candidate;
        hoverTimer = window.setTimeout(() => {
          if (hoverCandidate === candidate) this.select(candidate);
        },75);
      };
      listen(stage,'pointermove', event => {
        if (!hoverQuery.matches || event.pointerType === 'touch' || event.buttons) return;
        pendingPointer = {x:event.clientX,y:event.clientY};
        if (!pointerFrame) pointerFrame = requestAnimationFrame(processPointer);
      }, {passive:true});
      listen(stage,'pointerleave',clearHover);
      this.items.forEach((item,i) => listen(item,'focus', () => {
        if (item.matches(':focus-visible')) this.select(i);
      }));
      this.cancelHover = clearHover;
      this.trackRackScroll = () => {
        if (!pendingPointer) return;
        clearHover();
      };
      listen(window,'scroll',this.trackRackScroll,{passive:true});
      listen(stage,'pointerdown', event => { this.start = {x:event.clientX,y:event.clientY}; });
      listen(stage,'pointerup', event => {
        if (!this.start) return;
        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true;
          this.select(this.selected + (dx < 0 ? 1 : -1));
          setTimeout(() => { this.swiped = false; }, 300);
        }
      });
      listen(stage,'pointercancel', () => { this.start = null; });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.removeAttribute('data-ready');
          this.select(this.selected);
        });
        this.resizeObserver.observe(stage);
      }
      this.select(-1);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.cancelHover?.();
      window.removeEventListener('scroll',this.trackRackScroll);
      this.initialized = false;
    }
    openProduct(index) {
      const dialog = this.querySelector(`[data-rack-dialog="${index}"]`);
      if (!dialog || dialog.open) return;
      dialog.showModal();
    }
    async purchase(form,checkout) {
      if (form.dataset.busy === 'true' || !form.reportValidity()) return;
      form.dataset.busy = 'true';
      const buttons = [...form.querySelectorAll('[data-rack-submit]')];
      const message = form.querySelector('[data-rack-message]');
      message.textContent = '';
      message.removeAttribute('data-error');
      buttons.forEach(button => { button.disabled = true; });
      form.setAttribute('aria-busy','true');
      let added = false;
      try {
        const data = new FormData(form);
        const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId);
        if (sections.length) data.set('sections',[...new Set(sections)].slice(0,5).join(','));
        data.set('sections_url',window.location.pathname);
        const response = await fetch(`${form.action}.js`,{method:'POST',body:data,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || form.dataset.error);
        added = true;
        message.textContent = form.dataset.added;
        if (checkout) {
          this.querySelector('[data-rack-checkout]').requestSubmit(this.querySelector('[data-rack-checkout] button'));
          return;
        }
        try {
          const cartResponse = await fetch(`${this.dataset.cartUrl}.js`,{headers:{Accept:'application/json'}});
          const cart = await cartResponse.json();
          const {CartAddEvent} = await import('@theme/events');
          form.closest('dialog').close();
          this.dispatchEvent(new CartAddEvent(cart,data.get('id'),{source:'product-form-component',productId:form.dataset.productId,itemCount:1,sections:result.sections}));
        } catch {
          message.textContent = form.dataset.added;
        }
      } catch (error) {
        message.dataset.error = 'true';
        message.textContent = added ? form.dataset.added : (error.message || form.dataset.error);
      } finally {
        form.dataset.busy = 'false';
        form.removeAttribute('aria-busy');
        buttons.forEach(button => { button.disabled = !form.querySelector('input[name="id"]:checked'); });
      }
    }
    select(index) {
      const next = Math.max(-1,Math.min(this.items.length - 1,index));
      if (this.selected === next && this.hasAttribute('data-ready')) return;
      this.selected = next;
      this.setAttribute('data-ready','');
      const stageWidth = this.stage?.clientWidth || 1200;
      const mobile = stageWidth < 750;
      const halfReveal = Math.min(mobile ? stageWidth * .37 : 220,stageWidth * .42);
      this.items.forEach((item,i) => {
        const slot = (.27 + (i + .5) / this.items.length * .46) * stageWidth;
        const center = Math.max(halfReveal,Math.min(stageWidth - halfReveal,slot));
        item.style.setProperty('--rack-reveal-shift',`${center - slot}px`);
      });
      this.toggleAttribute('data-active',this.selected >= 0);
      this.querySelector('[data-rack-neutral]').hidden = this.selected >= 0;
      this.style.setProperty('--rack-selected',this.selected);
      this.style.setProperty('--rack-tilt','0deg');
      this.style.setProperty('--rack-sway','0deg');
      this.items.forEach((item,i) => {
        item.style.setProperty('--rack-side-angle',i < this.selected ? '48deg' : '-48deg');
        item.style.setProperty('--rack-push',i < this.selected ? '-46px' : '46px');
        item.classList.toggle('is-selected',i === this.selected);
        item.setAttribute('aria-pressed',String(i === this.selected));
      });
      this.panels.forEach((panel,i) => { panel.hidden = i !== this.selected; });
      this.querySelector('[data-rack-counter]').textContent = `${this.selected < 0 ? '—' : String(this.selected + 1).padStart(2,'0')} / ${String(this.items.length).padStart(2,'0')}`;
      this.querySelector('[data-rack-step="-1"]').disabled = this.selected === 0;
      this.querySelector('[data-rack-step="1"]').disabled = this.selected === this.items.length - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
